import React from "react"
import { useSelector } from "react-redux"
import { Paper, Typography } from "@material-ui/core"

import {
  selectChannel,
  selectContactAssociatedChannels,
} from "@root/store/selectors"

import { useSettingStyles } from "../styles"
import Associated from "./Associated"
import ContactAttributes from "./ContactAttributes"
import ContactTags from "./ContactTags"
import NamedUser from "./NamedUser"
import { RootState } from "@root/store"
import SnackContext from "@root/components/Snackbar"
import ContactPreferenceCenters from "./ContactPreferenceCenters"
import ContactSubscriptions from "./ContactSubscriptions"

const Contact: React.FC = () => {
  const classes = useSettingStyles()
  const { error } = useSelector((state: RootState) => state.contact)
  const channel = useSelector(selectChannel)
  const associated = useSelector(selectContactAssociatedChannels)
  const { createSnack } = React.useContext(SnackContext)

  React.useEffect(() => {
    if (error) {
      createSnack(error)
    }
  }, [error])

  const showNamedUser = Boolean(channel || associated.length)

  return (
    <>
      {showNamedUser && (
        <Paper className={classes.paper} data-qa-selector="contact-named-user">
          <NamedUser />
        </Paper>
      )}
      <Paper className={classes.paper} data-qa-selector="contact-tags">
        <Typography variant="h4">Tags</Typography>
        <ContactTags />
      </Paper>
      <Paper className={classes.paper} data-qa-selector="contact-attributes">
        <Typography variant="h4">Attributes</Typography>
        <ContactAttributes />
      </Paper>
      <Paper
        className={classes.paper}
        data-qa-selector="contact-associated-channels"
      >
        <Typography variant="h4">Associated Channels</Typography>
        <Associated />
      </Paper>
      <Paper className={classes.paper} data-qa-selector="contact-subscriptions">
        <Typography variant="h4">Subscription Lists</Typography>
        <ContactSubscriptions />
      </Paper>
      <Paper
        className={classes.paper}
        data-qa-selector="contact-preference-centers"
      >
        <Typography variant="h4">Preference Centers</Typography>
        <ContactPreferenceCenters />
      </Paper>
    </>
  )
}

export default Contact
